// @flow

import * as React from 'react';
import { Pressable, useWindowDimensions, View } from 'react-native';
import { FormattedMessage } from 'react-intl';
import { pageStyles } from '../defaultPageStyles';
import Text from '../../components/CustomText/CustomText';
import { setRowStyle } from '../Profile/RemainingChannelItem';

type Props = {
    index: Number,
    item: Object,
    addedProfiles: Array<Object>,
    setAddedProfiles: () => void,
    profiles: Array<Object>,
    setProfiles: () => void,
}

const AllProfiles = (props: Props) => {
    const {
        index, item, addedProfiles, setAddedProfiles, profiles, setProfiles,
    } = props;

    const [hovered, setHovered] = React.useState(false);

    const { width } = useWindowDimensions();

    return (
        <View
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            style={setRowStyle(hovered, item, index, width)}
        >
            <View
                style={pageStyles.channel_items_container}
            >
                <View style={
                    width > 600
                        ? [pageStyles.channel_items, pageStyles.channel_items_number_column]
                        : [pageStyles.channel_items, pageStyles.channel_items_number_column_phone]
                }
                />
                <Text style={
                    width > 600
                        ? [pageStyles.channel_items, pageStyles.channel_items_name_column]
                        : [pageStyles.channel_items, pageStyles.channel_items_name_column_phone]
                }
                >
                    {item.name}
                </Text>
                {width > 600 && (
                    <>
                        <View
                            style={[pageStyles.channel_items, pageStyles.channel_items_third_column]}
                        />
                        <View
                            style={[pageStyles.channel_items, pageStyles.channel_items_fourth_column]}
                        />
                    </>
                )}
                <View
                    style={width > 600
                        ? [pageStyles.channel_items, pageStyles.channel_items_action_button_column]
                        : [pageStyles.channel_items, pageStyles.channel_items_action_button_column_phone_all]}
                >
                    <Pressable
                        onPress={() => {
                            if (addedProfiles.includes(item)) {
                                return;
                            }
                            setAddedProfiles([item, ...addedProfiles]);
                            setProfiles(profiles.filter((value, i) => i !== index));
                        }}
                        style={pageStyles.action_buttons}
                    >
                        <Text style={pageStyles.light_blue}>
                            <FormattedMessage
                                id="add-profile-in-device"
                                defaultMessage="Add Profile in Device"
                            />
                        </Text>
                    </Pressable>
                </View>
            </View>
        </View>
    );
};

export default AllProfiles;
